import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DataList from './DataList';
import api from '../../services/api';

const CompaniesList = () => {
  const [open, setOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'title', label: 'Название' },
  ];

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({ ...item });
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      await api.put(`/api/companies/${editingItem.id}/`, formData);
      setOpen(false);
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Ошибка сохранения:', err);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditingItem(null);
    setFormData({});
  };

  const renderActions = (item) => (
    <IconButton onClick={() => handleEdit(item)} size="small">
      <EditIcon />
    </IconButton>
  );

  return (
    <>
      <DataList endpoint="/api/companies/" columns={columns} renderActions={renderActions} refreshTrigger={refreshTrigger} />
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Редактировать компанию</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Название"
            fullWidth
            variant="standard"
            value={formData.title || ''}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button onClick={handleSave}>Сохранить</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CompaniesList;